<div class="venue__item d-flex flex-row">
  <div class="d-flex flex-row">
    <img [src]="venue?.pictureUrl ? venue?.pictureUrl:'./assets/images/icons/venue-logo-placeholder-01.svg'" alt="profile-picture">
    <div class="venue-info">
      <div><span>{{ venue?.name }}</span>&nbsp;|&nbsp;{{ venue?.city }}&nbsp;<mat-icon style="font-size: 14px; color: yellow; width: 18px; height: 18px;">star_rate</mat-icon>{{venue?.rate ? venue?.rate:'0'}}&nbsp;<span>({{venue?.numberOfReviews ? venue?.numberOfReviews:'0'}})</span></div>
      <a href="{{venue?.websiteUrl}}" target="_blank">{{venue?.websiteUrl}}</a>
    </div>
  </div>
  <div class="d-flex flex-row">
    <div class="venue-address">
      <div class="d-flex flex-row">
        <mat-icon class="icon">location_on</mat-icon><span>{{ venue?.address }}</span>
      </div>
      <div class="d-flex flex-row">
        <!-- <mat-icon class="icon">person</mat-icon><span>Esmeralda Esteban</span>&nbsp;|&nbsp;<span>{{ 'VENUES.ADMIN' | translate }}</span> -->
      </div>
    </div>
    <div class="venue-settings">
      <div class="d-flex flex-row">
        <a [routerLink]='["/venues/" + venue?.id + "/reports"]'>
          {{ 'REPORTS.REPORTS' | translate }}
        </a>
        <img class="reports-icon" src="assets/images/icons/show_chart_24px.svg">
      </div>
      <div (click)="viewVenue(venue?.id)" class="d-flex flex-row">
        <span>{{ 'VIEW' | translate }}</span><mat-icon class="reports-icon">search</mat-icon>
      </div>
      <div (click)="addVenueCapacity(venue?.id)" class="d-flex flex-row">
        <span class="edit-capacity-span">{{ 'VENUES.EDIT_CAPACITY' | translate }}</span><mat-icon class="reports-icon">edit</mat-icon>
      </div>
    </div>
  </div>
</div>
